import type { Role } from '@gigdriver/domain';
import { callable } from './functions';

// Change a member's role or remove them. Server-side only (owner/admin; the
// owner hierarchy and last-owner guard are enforced in the callable) —
// firestore.rules deny client writes to member docs.
export const updateMemberRole = callable<{ orgId: string; uid: string; role: Role }, { ok: true }>('updateMemberRole');
export const removeMember = callable<{ orgId: string; uid: string }, { ok: true }>('removeMember');
